import {useQuery, keepPreviousData} from '@tanstack/react-query';
import {skus} from '@api/apis';
import {IHash} from 'types/base.types';
import {StatusErrors} from '@constants/base';

/* Selectors */
import {useCartPlanSelector} from '@store/queries/cart/useCart.selector';
import {useUserHasPlanOrSubscription} from '@store/queries/user/useUser.selector';

/* Keys */
import {subscriptionsQueryKeys} from './queries.keys';

/**
 * Note: Pass in options to override defaults, if needed.
 * @params: returned:
 * data, isLoading, isError, error, status, isFetching, refetch
 */
interface ISubscriptionsAll {
  id: number;
  skuId: number;
  options?: IHash<any>;
}

const useSubscriptionsQueryEstimate = ({id, skuId, options = {}}: ISubscriptionsAll) => {
  /* Estimate changed. If we have a subscription or plan in cart let api handle */
  /* 1. Does user have a plan or subscription? */
  const hasPlanOrSubscription = useUserHasPlanOrSubscription();
  /* 2. Does user have a plan in cart? */
  const {id: planIdInCart} = useCartPlanSelector();

  const defaultOptions = {
    enabled: !!(id && skuId),
    cacheTime: 0,
    placeholderData: keepPreviousData,
  };
  /* merge default options with passed in options/config */
  const mergedOptions = {
    ...defaultOptions,
    ...options,
  };

  return useQuery({
    queryKey: subscriptionsQueryKeys.estimate(id || 0, skuId),

    queryFn: async () => {
      const {data} = await skus.estimate({skuId}, !hasPlanOrSubscription && !planIdInCart ? {enforce_plan_id: id} : {});

      return {
        prices: data?.prices || {},
        status: data?.status || StatusErrors.get(500),
      };
    },
    ...mergedOptions,
  });
};

export default useSubscriptionsQueryEstimate;
